import { render, staticRenderFns } from "./UserJoin.vue?vue&type=template&id=4a7a1fd6&scoped=true"
import script from "./UserJoin.vue?vue&type=script&lang=js"
export * from "./UserJoin.vue?vue&type=script&lang=js"
import style0 from "./UserJoin.vue?vue&type=style&index=0&id=4a7a1fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a1fd6",
  null
  
)

export default component.exports